import { makeStyles } from "tss-react/mui";
import { DATE_TIME_FORMATS } from "@miplatform/constants";
import { IInspectionAttempt } from "@miplatform/types";
import { getFormattedDate } from "@miplatform/utils";
import { Box, Typography } from "@mui/material";
import { MiStackedTypography } from "../MiStackedTypography/MiStackedTypography";
import { WorkCardHeader } from "../MiWorkCard/WorkCardHeader";

export const MiInspectionPopper = ({
  inspection,
  headerColor,
}: {
  inspection: IInspectionAttempt;
  headerColor?: string;
}) => {
  const { classes, theme } = useStyles();

  const { templateName, home, approvedStartDate, attemptNumber } = inspection;
  const { address, builderName, communityName } = home;
  const { addressLine1, city, postalCode } = address;

  return (
    <Box className={classes.popper}>
      <WorkCardHeader
        title={templateName}
        backgroundColor={headerColor ?? theme.palette.primary.main}
        className={classes.popperHeader}
        fontSize="0.75rem"
      />
      <Box className={classes.homeDetails}>
        <Typography variant="HD2">
          {addressLine1} | {city}
        </Typography>
        <Typography variant="BD1" color="textSecondary">
          {builderName} | {communityName} | {postalCode}
        </Typography>
      </Box>
      <Box className={classes.scheduleDetails}>
        <MiStackedTypography
          title="Scheduled"
          description={getFormattedDate(
            DATE_TIME_FORMATS.FORMAT_M_D_YY,
            approvedStartDate
          )}
          descriptionProps={{ fontWeight: "bold" }}
        />
        <MiStackedTypography
          title="Attempt"
          description={`Attempt ${attemptNumber}`}
          descriptionProps={{ fontWeight: "bold" }}
        />
      </Box>
    </Box>
  );
};
const useStyles = makeStyles()((theme) => ({
  popper: {
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    overflow: "hidden",
    boxShadow: `0 4px 3px 0  rgba(0,0,0, 0.07), 0 2px 2px 0 rgba(0,0,0, 0.06)`,
    color: theme.palette.text.primary,
  },
  popperHeader: {
    height: 24,
  },
  homeDetails: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
  scheduleDetails: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[100],
    display: "flex",
    gap: theme.spacing(2),
  },
}));
